module.exports = __webpack_public_path__ + "a327989e37e4d88852eacbb58ade10f6.png";